(function () {
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var flavors = [];
    try { flavors = JSON.parse(root.querySelector('[data-bzp-data]').textContent); } catch (e) { return; }
    if (!flavors.length) return;
    var tiers = root.querySelectorAll('[data-bzp-tier]');
    var addBtn = root.querySelector('[data-bzp-add]');
    var err = root.querySelector('[data-bzp-error]');
    var active = root.querySelector('[data-bzp-tier].is-on') || tiers[0];
    var picks = [];

    function defaults(n) {
      var used = {}, out = [];
      for (var i = 0; i < n; i++) {
        var pick = -1;
        for (var k = 0; k < flavors.length; k++) {
          var f = flavors[k];
          if (f.available && (used[k] || 0) < f.max) { pick = k; break; }
        }
        if (pick < 0) pick = 0;
        used[pick] = (used[pick] || 0) + 1;
        out.push(pick);
      }
      return out;
    }
    function options(sel) {
      return flavors.map(function (f, i) {
        return '<option value="' + i + '"' + (i === sel ? ' selected' : '') + (f.available ? '' : ' disabled') + '>' + esc(f.name) + (f.available ? '' : ' (sold out)') + '</option>';
      }).join('');
    }
    function render() {
      tiers.forEach(function (t) {
        var on = t === active;
        t.classList.toggle('is-on', on);
        t.querySelector('[data-bzp-pick]').setAttribute('aria-pressed', on ? 'true' : 'false');
        var slots = t.querySelector('[data-bzp-slots]');
        if (!on) { slots.innerHTML = ''; return; }
        var n = parseInt(t.dataset.n, 10);
        if (picks.length !== n) {
          var keep = picks.slice(0, n), more = defaults(n);
          picks = keep.concat(more.slice(keep.length));
        }
        var html = '<p class="bzp-slots__label">Flavor</p>';
        picks.forEach(function (p, i) {
          html += '<label class="bzp-slot">' +
            (n > 1 ? '<span class="bzp-slot__n">#' + (i + 1) + '</span>' : '') +
            '<span class="bzp-slot__img">' + (flavors[p].img ? '<img src="' + esc(flavors[p].img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<select data-i="' + i + '" aria-label="Flavor for can ' + (i + 1) + '">' + options(p) + '</select></label>';
        });
        slots.innerHTML = html;
      });
      total();
    }
    function total() {
      var pct = parseFloat(active.dataset.pct) || 0;
      var full = 0;
      picks.forEach(function (p) { full += flavors[p].price; });
      var sum = full * (100 - pct) / 100;
      addBtn.textContent = 'Add to cart • ' + money(sum);
      err.hidden = true;
    }

    tiers.forEach(function (t) {
      t.querySelector('[data-bzp-pick]').addEventListener('click', function () {
        if (active === t) return;
        active = t;
        render();
      });
    });
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-i]');
      if (!sel) return;
      var i = parseInt(sel.dataset.i, 10);
      picks[i] = parseInt(sel.value, 10);
      var img = sel.parentNode.querySelector('.bzp-slot__img');
      var f = flavors[picks[i]];
      if (img) img.innerHTML = f.img ? '<img src="' + esc(f.img) + '" alt="" loading="lazy">' : '';
      total();
    });

    addBtn.addEventListener('click', function () {
      var n = parseInt(active.dataset.n, 10);
      var counts = {}, order = [];
      picks.forEach(function (p) {
        if (!counts[p]) { counts[p] = 0; order.push(p); }
        counts[p]++;
      });
      for (var j = 0; j < order.length; j++) {
        var f = flavors[order[j]];
        if (!f.available) { err.textContent = f.name + ' is sold out. Please pick another flavor.'; err.hidden = false; return; }
        if (counts[order[j]] > f.max) { err.textContent = 'Only ' + f.max + ' ' + f.name + ' left. Please swap a can for another flavor.'; err.hidden = false; return; }
      }
      var bid = 'P' + Date.now().toString(36).toUpperCase();
      var body = { items: order.map(function (p) {
        var item = { id: flavors[p].id, quantity: counts[p] };
        if (n > 1) item.properties = { _bundle: bid, _pack: String(n) };
        return item;
      }) };
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var label = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          addBtn.textContent = label;
          if (!res.ok) { err.textContent = res.d.description || res.d.message || 'Something went wrong. Please try again.'; err.hidden = false; return; }
          if (drawer && res.d.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(res.d); }
          else { window.location.href = rootUrl + 'cart'; }
        })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = label; err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-bzp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();